import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Reset Your Password", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Send code ")
const _hoisted_3 = { class: "form__message" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Don't have an account? ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sign up")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createVNode(_component_base_input, {
      class: "full-width",
      placeholder: "Email",
      error: _ctx.emailError,
      modelValue: _ctx.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
      modelModifiers: { trim: true }
    }, null, 8, ["error", "modelValue"]),
    _createVNode(_component_loading_button, {
      "button-type": "button--inverted",
      loading: _ctx.loading
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["loading"]),
    _createElementVNode("p", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_router_link, {
        class: "anchor--primary",
        to: "/signup"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _hoisted_6
    ])
  ], 32))
}